<template>
<div>
  <el-dialog
    :title="title"
    :close-on-click-modal="false"
     v-dialogDrag
     width="500px"
    :visible.sync="visible">
    <el-form :model="inputForm" size="small" ref="inputForm" v-loading="loading" :class="method==='view'?'readonly':''"  :disabled="method==='view'"
             label-width="120px">
      <el-row  :gutter="15">
        <el-col :span="24">
            <el-form-item label="中文名称" prop="nameCn"
                :rules="[
                  {required: true, message:'中文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameCn" placeholder="请填写中文名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="英文名称" prop="nameEn"
                :rules="[
                  {required: true, message:'英文名称不能为空', trigger:'blur'}
                 ]">
              <el-input v-model="inputForm.nameEn" placeholder="请填写英文名称"  maxlength="64"    ></el-input>
           </el-form-item>
        </el-col>
        <el-col :span="24">
            <el-form-item label="所属项目" prop="project.id"
                :rules="[
                  {required: true, message:'所属项目不能为空', trigger:'blur'}
                 ]">
          <GridSelect
            title="选择所属项目"
            labelName = 'nameEn'
            labelValue = 'id'
            :value = "inputForm.project.id"
            :limit="10"
            @getValue='(value) => {inputForm.project.id=value}'
            :columns="[
            {
              prop: 'code',
              label: '编码'
            },
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            :searchs="[
            {
              prop: 'code',
              label: '编码'
            },
            {
              prop: 'nameCn',
              label: '中文名称'
            },
            {
              prop: 'nameEn',
              label: '英文名称'
            }
            ]"
            dataListUrl="/unmspace/cecUnmProject/list"
            queryEntityUrl="/unmspace/cecUnmProject/queryById">
          </GridSelect>
           </el-form-item>
        </el-col>
        </el-row>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="visible = false">关闭</el-button>
      <el-button size="small" type="primary" v-if="method != 'view'" @click="doSubmit()" v-noMoreClick>确定</el-button>
    </span>
  </el-dialog>
</div>
</template>

<script>
  import GridSelect from '@/components/gridSelect'
  import cecUnmMaterialSchemeService from '@/api/unmspace/cecUnmMaterialSchemeService'
  export default {
    data () {
      return {
        title: '',
        method: '',
        visible: false,
        loading: false,
        inputForm: {
          id: '',
          nameEn: '',
          nameCn: '',
          project: {
            id: ''
          }
        }
      }
    },
    components: {
      GridSelect
    },
    methods: {
      init (method, id) {
        this.method = method
        this.inputForm.id = id
        if (method === 'add') {
          this.title = `新建材料方案管理`
        } else if (method === 'edit') {
          this.title = '修改材料方案管理'
        } else if (method === 'view') {
          this.title = '查看材料方案管理'
        }
        this.visible = true
        this.loading = false
        this.$nextTick(() => {
          this.$refs.inputForm.resetFields()
          if (method === 'edit' || method === 'view') { // 修改或者查看
            this.loading = true
            cecUnmMaterialSchemeService.queryById(this.inputForm.id).then(({data}) => {
              this.inputForm = this.recover(this.inputForm, data)
              this.loading = false
            })
          }
        })
      },
      // 表单提交
      doSubmit () {
        this.$refs['inputForm'].validate((valid) => {
          if (valid) {
            this.loading = true
            cecUnmMaterialSchemeService.save(this.inputForm).then(({data}) => {
              this.visible = false
              this.$message.success(data)
              this.$emit('refreshDataList')
              this.loading = false
            }).catch(() => {
              this.loading = false
            })
          }
        })
      }
    }
  }
</script>

  
